module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/doutor-39666bf190a87ce0a97e0544a25d58bf.jpg";